import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const YM_ID = Number(process.env.REACT_APP_YM_ID || 0);

export function useYandexMetricaHits() {
    const location = useLocation();
    const prevUrlRef = useRef<string>('');
    useEffect(() => {
        if (process.env.NODE_ENV !== 'production') return;
        if (!YM_ID) return;
        const url = window.location.pathname + window.location.search + window.location.hash;
        setTimeout(() => {
            const options = {
                referer: prevUrlRef.current || undefined,
                title: document.title || undefined,
            } as const;
            const w = window as any;
            if (typeof w.ym === 'function') {
                w.ym(YM_ID, 'hit', url, options);
            } else {
                w.ym = function () {
                    (w.ym.a = w.ym.a || []).push(arguments);
                };
                (w.ym.a = w.ym.a || []).push([YM_ID, 'hit', url, options]);
            }
            prevUrlRef.current = url;
        }, 0);
    }, [location.pathname, location.search, location.hash]);
}
